export default class contactForm {
  constructor() {
    document.addEventListener('wpcf7mailsent', () => {
      $('.wpcf7-form .field, .wpcf7-form .wpcf7-submit, .wpcf7-form .ajax-loader').hide(100);
    }, false );
  }
}



// WEBPACK FOOTER //
// ./scripts/contactForm.js